import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './components/alert.component';

@NgModule({
  declarations: [
    AlertComponent,
  ],
  exports: [
    AlertComponent,
  ],
  imports: [ CommonModule ],
  providers: [],
})
export class AlertModule {
}
